module.exports = __webpack_public_path__ + "static/media/video-1.229f5279.mp4";